import { HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';

import { APOLLO_CLIENT_NAMES } from '@customer-portal/shared/constants';
import {
  apolloThrowIfNotSuccess,
  catchErrorAndEvict,
  getQueryRootFieldName,
} from '@customer-portal/shared/helpers/custom-operators';

import { QUALTRICS_SURVEY_FEEDBACK_SUBMIT } from '../../../graphql/mutations/qualtrics-survey-feedback-submit.graphql';
import { QUALTRICS_SURVEY_FEEDBACK_QUESTIONS_DETAILS } from '../../../graphql/queries/qualtrics-survey-feedback-details.graphql';
import {
  QualtricsSubmitResponse,
  QualtricsSurveyModel,
  QualtricsSurveySubmit,
} from '../../../models/qualtrics-feedback-form.model';

@Injectable({ providedIn: 'root' })
export class QualtricsSurveyFeedbackService {
  private readonly apollo = inject(Apollo);

  private clientName = APOLLO_CLIENT_NAMES.notification;

  getQualtricsSurveyDetails(): Observable<QualtricsSurveyModel> {
    const fieldName =
      getQueryRootFieldName(QUALTRICS_SURVEY_FEEDBACK_QUESTIONS_DETAILS) ||
      'surveyInfo';

    return this.apollo
      .use(this.clientName)
      .query({
        query: QUALTRICS_SURVEY_FEEDBACK_QUESTIONS_DETAILS,
        variables: {},
      })
      .pipe(
        apolloThrowIfNotSuccess(fieldName),
        map((result: any) => result.data.surveyInfo),
        catchErrorAndEvict(this.apollo, this.clientName, fieldName),
      );
  }

  onSubmitQualtricsSurveyFeedback(
    payload: QualtricsSurveySubmit,
  ): Observable<QualtricsSubmitResponse> {
    const values = payload?.qualtricsmsg?.values ?? {};
    const surveyDetails = payload?.surveyDetails;

    return this.apollo
      .use(this.clientName)
      .mutate({
        mutation: QUALTRICS_SURVEY_FEEDBACK_SUBMIT,
        variables: {
          values,
          surveyId: surveyDetails.surveyId,
          qualtricsSurveyId: surveyDetails.qualtricsSurveyId,
          versionNumber: surveyDetails.versionNumber,
          responseId: surveyDetails.responseId,
          triggerConfigurationId: surveyDetails.triggerConfigurationId,
        },
        context: {
          headers: new HttpHeaders({ SKIP_LOADING: 'true' }),
        },
      })
      .pipe(map((result: any) => result.data.SurveyResponseSubmission));
  }
}
